import React from 'react';
export const EmoticonItem = (props) => {
    const { entity } = props;
    const hasEntity = Object.keys(entity).length;
    if (!hasEntity)
        return null;
    const { parts, token } = entity.tokenizedDisplayName ?? {};
    const renderName = () => parts?.map((part, i) => part.toLowerCase() === token ? (React.createElement("span", { className: 'str-chat__emoji-item--highlight', key: `part-${i}` }, part)) : (React.createElement("span", { className: 'str-chat__emoji-item--part', key: `part-${i}` }, part))) ?? null;
    return (React.createElement("div", { className: 'str-chat__emoji-item' },
        React.createElement("span", { className: 'str-chat__emoji-item--entity' }, entity.native),
        React.createElement("span", { className: 'str-chat__emoji-item--name' }, renderName())));
};
